var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{staticClass:"d-flex",attrs:{"content":_vm.translationTooltipContent,"placement":"right","disabled":_vm.disableTooltip,"enterable":false}},[_c('div',[_c('font-awesome-icon',{class:[_vm.iconColor, 'danger-icon'],attrs:{"icon":['fal', 'exclamation-triangle']}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }